import type { CityConfig } from "../city-template/types";

export const springfieldVaConfig: CityConfig = {
  city: "Springfield",
  state: "Virginia",
  stateAbbr: "VA",
  slug: "springfield-va",
  route: "/cities/springfield-va",
  title: "Emergency Passport Springfield, VA — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Springfield, VA — as fast as 24 hours. Same-day courier processing available. A+ BBB rated, registered State Dept. courier serving Springfield, I-95 corridor, and the Northern Virginia inner ring. Get your passport fast!",
  h1: "Emergency & Expedited Passport Services in Springfield, VA",
  heroSubtitle: "Passport expired before your trip? Traveling from the I-95 corridor, Franconia, or the Northern Virginia inner ring? We help Springfield travelers get expedited passports as quickly as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Springfield%20Virginia%20suburban%20community%20with%20the%20Springfield%20Town%20Center%20shopping%20district%20and%20Franconia-Springfield%20Metro%20station%2C%20modern%20retail%20buildings%20alongside%20tree-lined%20residential%20neighborhoods%2C%20I-95%20corridor%20visible%20in%20the%20background%2C%20warm%20afternoon%20light%20with%20manicured%20lawns%20and%20Northern%20Virginia%20suburban%20development%2C%20professional%20photography%20showcasing%20this%20family-friendly%20Fairfax%20County%20community%20near%20Washington%20DC%2C%20no%20people%20visible%2C%20scenic%20suburban%20landscape%20with%20modern%20shopping%20centers%20and%20well-kept%20homes&width=1800&height=700&seq=springfield-va-hero-001&orientation=landscape",
  heroImageAlt: "Springfield Virginia suburban community with Town Center and Franconia-Springfield Metro",
  geoPosition: "38.7893;-77.1870",
  geoPlacename: "Springfield, Virginia",
  lastModified: "2026-07-21",
  regionalAgency: {
    name: "Washington Passport Agency",
    address: "600 19th Street NW, Washington, DC 20006",
    distance: "Located in downtown Washington, DC — approximately 15 miles northeast of Springfield via I-395 or the Franconia-Springfield Metro",
  },
  nearbyCitiesZips: [
    { name: "Springfield", zips: "22150, 22151, 22152, 22153, 22156, 22158, 22159, 22160, 22161" },
    { name: "Franconia", zips: "22310, 22315" },
    { name: "Burke", zips: "22009, 22015, 22032" },
    { name: "Lorton", zips: "22079, 22199" },
    { name: "Alexandria", zips: "22301, 22302, 22304, 22305, 22306, 22307, 22308, 22309, 22310, 22311, 22312, 22314, 22315" },
    { name: "Fairfax", zips: "22030, 22031, 22032, 22033, 22034, 22035, 22036, 22037, 22038, 22039" },
    { name: "Annandale", zips: "22003" },
    { name: "Falls Church", zips: "22041, 22042, 22043, 22044, 22046" },
    { name: "Tysons", zips: "22102, 22182" },
    { name: "McLean", zips: "22101, 22102, 22106" },
    { name: "Vienna", zips: "22180, 22181, 22182, 22183, 22185" },
    { name: "Woodbridge", zips: "22191, 22192, 22193, 22194, 22195" },
    { name: "Manassas", zips: "20108, 20109, 20110, 20111, 20112, 20113" },
    { name: "Arlington", zips: "22201, 22202, 22203, 22204, 22205, 22206, 22207, 22209, 22211, 22213, 22214" },
    { name: "Centreville", zips: "20120, 20121, 20122" },
  ],
  benefits: [
    { icon: "ri-time-line", title: "24–48 Hour Processing", desc: "Emergency courier submission for urgent travel departures from the Springfield and I-95 corridor" },
    { icon: "ri-shield-check-line", title: "Registered Courier", desc: "U.S. Department of State approved passport expediting" },
    { icon: "ri-user-line", title: "Dedicated Agent", desc: "A real person assigned to your case from start to finish" },
    { icon: "ri-map-pin-2-line", title: "NoVA I-95 Corridor Hub", desc: "Serving Springfield, Burke, Franconia, Lorton, and the Fairfax County southern corridor" },
  ],
  internalLinks: [
    { name: "Virginia state passport services", route: "/states/virginia" },
    { name: "Alexandria VA passport services", route: "/cities/alexandria-va" },
    { name: "Fairfax VA passport services", route: "/cities/fairfax-va" },
    { name: "Burke VA passport services", route: "/cities/burke-va" },
    { name: "Falls Church VA passport services", route: "/cities/falls-church-va" },
    { name: "Woodbridge VA passport services", route: "/cities/woodbridge-va" },
  ],
  fpcOfficeNote: "Fast Passport Center serves Springfield remotely via secure courier. We do not have a walk-in office in Springfield — our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities. This is how we achieve 24–48 hour turnaround for Springfield and Northern Virginia I-95 corridor travelers.",
  fpcOfficeAddress: "7272 Wisconsin Ave, Bethesda, Maryland 20814",
  fpcOfficeDistance: "Serving all of Springfield and the Northern Virginia I-95 corridor including Burke, Franconia, Lorton, Alexandria, and the Fairfax County southern corridor",
  serviceAreaIntro: "From the bustling Springfield Town Center to the quiet neighborhoods of Burke, from the transit-connected Franconia-Springfield Metro station to the growing communities along the I-95 corridor, from the family-friendly streets of Kings Park to the wooded areas near Lake Accotink, from the Alexandria border to the Fairfax County heartland — Fast Passport Center serves every corner of Springfield and the Northern Virginia I-95 corridor. We regularly help travelers from Burke, Lorton, Alexandria, and Fairfax get their passports fast.",
  nearbyCitiesIntro: "We serve all Springfield neighborhoods and the Northern Virginia I-95 corridor including Burke, Franconia, Lorton, Alexandria, Annandale, and Fairfax County.",
  howItWorksIntro: "Most Springfield travelers complete everything online and ship documents overnight. No need to drive to the Washington regional agency or wait in long government lines.",
  mistakesIntro: "Springfield travelers often face the temptation to drive to the Washington regional passport agency. Here are the most common mistakes that cause delays.",
  testimonialsIntro: "Springfield and Northern Virginia I-95 corridor travelers trust us when their departure is days away. Here is what some of them have to say.",
  faqIntro: "Have questions about expedited passports in Springfield? Here are the most common ones we hear from Northern Virginia I-95 corridor travelers.",
  statePageRoute: "/states/virginia",
  statePageName: "Virginia",
  dmvWebsite: "https://www.dmv.virginia.gov",
  dmvLabel: "Virginia DMV — Official Website",
  vitalRecordsIcon: "ri-heart-pulse-line",
  vitalRecordsLinks: [
    { icon: "ri-user-smile-line", label: "Birth Certificate", desc: "Request certified birth certificates from Virginia Department of Health Vital Records. Online, mail, or in-person options available for Springfield and Fairfax County residents.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-file-list-2-line", label: "Death Certificate", desc: "Obtain certified death certificates through Virginia Department of Health Vital Records. Required for estate, insurance, and legal matters.", url: "https://www.vdh.virginia.gov/vital-records/" },
    { icon: "ri-hearts-line", label: "Marriage Certificate", desc: "Request marriage license records from the Fairfax County Circuit Court Clerk. Certified copies available for name changes and legal purposes.", url: "https://www.fairfaxcounty.gov/" },
    { icon: "ri-file-copy-line", label: "Divorce Decree", desc: "Obtain certified divorce records through the Fairfax County Circuit Court Clerk. Required for name change passport corrections.", url: "https://www.fairfaxcounty.gov/" },
  ],
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Comparison", href: "#comparison" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-flashlight-line",
      title: "Emergency Passport",
      description: "For travelers with immediate departure needs — as fast as 24 hours for urgent Springfield international flights and last-minute travel.",
      bullets: ["24–48 hour turnaround available", "Registered courier hand-delivery", "Flight verification support"],
      badge: "Most Popular",
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-passport-line",
      title: "Passport Renewal",
      description: "Fast renewal for adults with a passport issued within the last 15 years at age 16 or older.",
      bullets: ["No clerk visit required for most", "Mail-in or courier options", "Lost passport replacement available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-add-circle-line",
      title: "New Passport",
      description: "First-time passport application guidance with acceptance clerk appointment support.",
      bullets: ["Acceptance facility locator", "Form DS-11 assistance", "Photo requirement guidance"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-alert-line",
      title: "Lost or Stolen Passport",
      description: "Passport replacement with DS-64 form guidance and police report documentation.",
      bullets: ["DS-64 form assistance", "Identity verification support", "Emergency replacement options"],
      badge: "Urgent",
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Passport services for minors under 16 with parental consent and acceptance clerk support.",
      bullets: ["DS-11 form for minors", "Parental consent guidance", "Both parents presence rules"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-edit-line",
      title: "Name Change",
      description: "Passport correction and name change service after marriage, divorce, or legal changes.",
      bullets: ["DS-5504 or DS-82 guidance", "Marriage certificate support", "Court order documentation"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Passport Renewal", description: "Fast passport renewal for U.S. citizens with a passport issued within the last 15 years at age 16 or older." },
    { name: "New Passport", description: "First-time passport application assistance with step-by-step guidance through the acceptance clerk process." },
    { name: "Lost or Stolen Passport", description: "Passport replacement service for lost or stolen passports, including DS-64 form guidance." },
    { name: "Child Passport", description: "Passport services for minors under 16, with parental consent guidance and acceptance clerk support." },
    { name: "Name Change", description: "Passport correction and name change service after marriage, divorce, or legal name changes." },
  ],
  testimonials: [
    {
      name: "Jennifer H.",
      location: "Springfield, VA",
      rating: 5,
      text: "I live near Springfield Town Center and needed an emergency passport for a family cruise to the Caribbean with 6 days notice. Fast Passport Center had my renewal in 4 days. I shipped from the UPS on Old Keene Mill Road and it was completely seamless. No need to drive to DC or wait in government lines.",
      service: "Emergency Passport",
    },
    {
      name: "Michael S.",
      location: "Burke, VA",
      rating: 5,
      text: "As a Burke resident, I was worried about finding expedited passport services close to home. Fast Passport Center made it incredibly easy. Everything was done online, and my renewal was back in 5 days. The convenience for Fairfax County families is unbeatable.",
      service: "Passport Renewal",
    },
    {
      name: "Laura T.",
      location: "Springfield, VA",
      rating: 5,
      text: "First passports for my two daughters before a school trip to France. Fast Passport Center handled all the parental consent requirements perfectly and had both passports in 5 days. For Springfield families, this is the best expedited passport service available.",
      service: "Child Passport",
    },
    {
      name: "Robert D.",
      location: "Franconia, VA",
      rating: 5,
      text: "Lost my passport 3 days before a business trip to Toronto. I was in absolute panic. Fast Passport Center had a replacement in my hands in 48 hours. They saved my career and my business trip. Franconia professionals need this service.",
      service: "Lost Passport",
    },
  ],
  facilities: [
    {
      id: "springfield-va-1",
      name: "Springfield Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "8401 Old Keene Mill Road",
      city: "Springfield",
      state: "VA",
      zip: "22152",
      phone: "(703) 451-0289",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
      distance: "Central Springfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Primary Springfield facility. Full passport services with appointment. Call ahead to confirm.",
      icon: "ri-mail-line",
    },
    {
      id: "springfield-va-2",
      name: "Burke Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6001 Burke Commons Road",
      city: "Burke",
      state: "VA",
      zip: "22015",
      phone: "(703) 425-7374",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
      distance: "Burke, adjacent to Springfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Burke and western Springfield area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "springfield-va-3",
      name: "Alexandria West Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "7900 Richmond Highway",
      city: "Alexandria",
      state: "VA",
      zip: "22306",
      phone: "(703) 660-0315",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM",
      distance: "Alexandria, east of Springfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves eastern Springfield and Alexandria area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "springfield-va-4",
      name: "Annandale Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "6900 Columbia Pike",
      city: "Annandale",
      state: "VA",
      zip: "22003",
      phone: "(703) 941-5314",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
      distance: "Annandale, north of Springfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Annandale and northern Springfield area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "springfield-va-5",
      name: "Woodbridge Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "2601 Prince William Parkway",
      city: "Woodbridge",
      state: "VA",
      zip: "22192",
      phone: "(703) 494-7394",
      hours: "Mon–Fri: 9:00 AM – 4:00 PM; Sat: 9:00 AM – 12:00 PM",
      distance: "Woodbridge, south of Springfield",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location Finder",
      notes: "Serves Woodbridge and southern Springfield area. Full passport services with appointment.",
      icon: "ri-mail-line",
    },
    {
      id: "springfield-va-6",
      name: "Fairfax County Clerk",
      type: "County Clerk",
      address: "4110 Chain Bridge Road",
      city: "Fairfax",
      state: "VA",
      zip: "22030",
      phone: "(703) 691-7320",
      hours: "Mon–Fri: 8:00 AM – 4:30 PM",
      distance: "Fairfax, near Springfield",
      website: "https://www.fairfaxcounty.gov/circuit",
      websiteLabel: "Fairfax County Clerk",
      notes: "Provides vital records and birth certificates. Not a passport acceptance facility but useful for document collection.",
      icon: "ri-building-2-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Needed", agency: "Yes — call NPIC, limited slots", fpc: "No — we handle everything for you" },
    { feature: "Processing Speed", agency: "Same-day if approved (rare)", fpc: "24–48 hours guaranteed for emergency" },
    { feature: "Document Review", agency: "No — rejected if wrong", fpc: "Yes — we check before submission" },
    { feature: "Travel to Agency", agency: "Yes — drive to DC via I-395", fpc: "No — ship from home or office" },
    { feature: "Agent Support", agency: "No — government clerk only", fpc: "Yes — dedicated agent assigned" },
    { feature: "Status Updates", agency: "No — no tracking provided", fpc: "Yes — daily email updates" },
    { feature: "Guaranteed Timing", agency: "No — subject to availability", fpc: "Yes — contractual turnaround times" },
    { feature: "Military & Government", agency: "No special handling", fpc: "Yes — priority for military and government travelers" },
    { feature: "Multi-Application Households", agency: "One slot per application", fpc: "Yes — family batch processing supported" },
  ],
  mistakes: [
    {
      icon: "ri-image-line",
      title: "Wrong Photo Size or Background",
      description: "Springfield photo shops often use generic sizes. Passport photos must be exactly 2x2 inches with a white or off-white background.",
    },
    {
      icon: "ri-file-list-line",
      title: "Incomplete DS-11 Form",
      description: "Missing signatures or using the wrong form type are the #1 reasons for rejection at Northern Virginia acceptance facilities.",
    },
    {
      icon: "ri-money-dollar-circle-line",
      title: "Wrong Payment Amount",
      description: "Fees change frequently. Many Springfield applicants show up with incorrect payment and have to reschedule their appointment.",
    },
    {
      icon: "ri-calendar-close-line",
      title: "No Proof of Travel",
      description: "Without flight confirmation or travel itinerary, the Washington DC regional agency will turn you away for emergency appointments.",
    },
    {
      icon: "ri-parent-line",
      title: "Missing Parental Consent",
      description: "For minors, both parents must appear or submit notarized consent. This trips up many Springfield families at the clerk.",
    },
    {
      icon: "ri-time-line",
      title: "Waiting Too Long to Start",
      description: "Springfield travelers often assume standard processing will be fine. It takes 8-11 weeks. Start expedited at least 3 weeks before travel.",
    },
  ],
  steps: [
    { number: "1", icon: "ri-file-list-line", title: "Apply Online", description: "Complete your application on our secure website in under 10 minutes." },
    { number: "2", icon: "ri-mail-send-line", title: "Ship Documents", description: "We send you a prepaid overnight label. Drop your documents at any UPS location in Springfield or nearby." },
    { number: "3", icon: "ri-shield-check-line", title: "We Review", description: "Our team checks every document for accuracy before hand-delivering to the State Department." },
    { number: "4", icon: "ri-passport-line", title: "Processing", description: "Your passport is processed at a U.S. Department of State facility using our registered courier slots." },
    { number: "5", icon: "ri-truck-line", title: "Delivery", description: "We overnight your new passport back to your Springfield address — trackable every step of the way." },
  ],
  faqs: [
    { q: "Can I get an emergency passport in Springfield before my international trip?", a: "Yes. Fast Passport Center provides emergency passport services in Springfield for travelers with urgent international departures. Our registered couriers hand-deliver your documents directly to U.S. Department of State facilities, achieving 24-48 hour turnaround — perfect for last-minute trips from the Northern Virginia I-95 corridor." },
    { q: "How fast can I renew my passport in Springfield?", a: "Fast Passport Center offers fast passport renewal in Springfield in as little as 24-48 hours through our emergency courier service. For less urgent travel, our 3-5 day expedited option provides the best value. Both options include full document review and a dedicated agent." },
    { q: "What is the closest passport agency to Springfield?", a: "The nearest regional passport agency to Springfield is the Washington Passport Agency, located approximately 15 miles northeast in downtown Washington, DC. Accessible via I-395 or the Franconia-Springfield Metro. For urgent processing without the commute, Fast Passport Center's registered courier service achieves 24-48 hour turnaround from Springfield." },
    { q: "Can I get a same-day passport appointment near Springfield?", a: "Same-day passport appointments are only available at the Washington Regional Passport Agency for documented life-or-death emergencies. For all other urgent travel, Fast Passport Center's 24-48 hour emergency courier processing is the fastest guaranteed option for Springfield residents." },
    { q: "Can I expedite a child passport in Springfield?", a: "Yes. Fast Passport Center expedites child passports in Springfield for minors under 16. Both parents must appear or submit notarized consent, along with the child's birth certificate and both parents' IDs. We walk Springfield and Fairfax County families through the entire process." },
    { q: "What should I do if I lost my passport before a trip?", a: "If you lost your passport before a trip, contact Fast Passport Center immediately. We provide lost passport replacement services in Springfield with DS-64 form guidance and identity verification support. Our emergency courier service can get your replacement passport in 24-48 hours." },
    { q: "How fast can I get a passport in Springfield?", a: "With Fast Passport Center's emergency courier service, Springfield travelers can receive their passport in as little as 24-48 hours. Our registered couriers hand-deliver your documents directly to U.S. Department of State processing facilities, bypassing standard mail delays." },
    { q: "Do I need to drive to the Washington Passport Agency?", a: "No. With Fast Passport Center, you complete everything online and ship your documents overnight. Our couriers handle the in-person delivery to State Department facilities. You only need to visit a local acceptance clerk if you're a first-time applicant or need a name change." },
    { q: "Where are the closest passport acceptance facilities near Springfield?", a: "Popular options include the Springfield Post Office (22152), Burke Post Office (22015), Alexandria West Post Office (22306), and Annandale Post Office (22003). All require appointments. We help you find the most convenient location and schedule your visit." },
    { q: "What if I live in Burke or Franconia?", a: "We serve the entire Springfield area including Burke, Franconia, Lorton, and all neighborhoods along the I-95 corridor. Our overnight shipping labels work from any UPS location, so your location doesn't affect processing speed." },
    { q: "How much does expedited passport service cost in Springfield?", a: "Government fees are fixed: $130 for a passport book (adult) plus a $60 expedite fee. Fast Passport Center's service fees vary by processing speed — emergency 24-48 hour processing, 3-5 day expedited, or standard options. Contact us for a personalized quote." },
  ],
  photoLocations: [
    { name: "CVS Pharmacy — Springfield", address: "8326 Old Keene Mill Rd, Springfield, VA 22152", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Springfield", address: "7830 Rolling Rd, Springfield, VA 22153", hours: "Mon-Sun: 7AM-11PM" },
    { name: "FedEx Office — Springfield", address: "6795 Springfield Mall, Springfield, VA 22150", hours: "Mon-Fri: 7AM-9PM, Sat: 8AM-6PM" },
    { name: "CVS Pharmacy — Burke", address: "9570 Old Keene Mill Rd, Burke, VA 22015", hours: "Mon-Sun: 8AM-10PM" },
    { name: "Walgreens — Alexandria", address: "7600 Richmond Hwy, Alexandria, VA 22306", hours: "Mon-Sun: 7AM-11PM" },
    { name: "CVS Pharmacy — Annandale", address: "7023 Columbia Pike, Annandale, VA 22003", hours: "Mon-Sun: 8AM-10PM" },
  ],
  dmvLocations: [
    {
      name: "Virginia DMV — Springfield",
      address: "8300 Old Keene Mill Rd, Springfield, VA 22152",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Driver's license and REAL ID services. Appointment recommended.",
      featured: true,
    },
    {
      name: "Virginia DMV — Fairfax",
      address: "10255 Main St, Fairfax, VA 22030",
      hours: "Mon-Fri: 8AM-5PM",
      note: "REAL ID and passport-related ID services. Appointment strongly recommended.",
      featured: false,
    },
    {
      name: "Virginia DMV — Alexandria",
      address: "1106 King St, Alexandria, VA 22314",
      hours: "Mon-Fri: 8AM-5PM",
      note: "Serves Alexandria and eastern Springfield area. REAL ID available.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "DCA",
      name: "Ronald Reagan Washington National Airport",
      distance: "Approximately 15 miles northeast of Springfield",
      address: "2401 Smith Blvd, Arlington, VA 22202",
      note: "The closest major airport to Springfield. Domestic and international flights. Accessible via I-395 or the Franconia-Springfield Metro.",
      flightUrl: "https://www.flyreagan.com/",
      flightLabel: "DCA Airport",
      featured: true,
    },
    {
      code: "IAD",
      name: "Washington Dulles International Airport",
      distance: "Approximately 25 miles west of Springfield",
      address: "1 Saarinen Cir, Dulles, VA 20166",
      note: "Major international hub for the DC metro area. Accessible via I-495 or Route 7.",
      flightUrl: "https://www.flydulles.com/",
      flightLabel: "IAD Airport",
      featured: false,
    },
    {
      code: "BWI",
      name: "Baltimore/Washington International Airport",
      distance: "Approximately 55 miles northeast of Springfield",
      address: "7050 Friendship Rd, Baltimore, MD 21240",
      note: "Alternative international hub for DC area travelers. Accessible via I-95.",
      flightUrl: "https://www.bwiairport.com/",
      flightLabel: "BWI Airport",
      featured: false,
    },
  ],
};